import React, { Component, Fragment } from "react";
import { Row, Col, Container, Image } from "react-bootstrap";

import styles from "./ProductsTwo.module.scss";

import AgriFlower from "../../assets/png/AgriFlower.png";
import AgriCool from "../../assets/png/AgriCool.png";
import AgriClean from "../../assets/png/AgriClean.png";

export default class ProductsTwo extends Component {
  render() {
    return (
      <section id={styles.Products}>
        <Container fluid >
          <Row>
            <Col lg={5} className={styles.containerTop}>
              <div id={styles.Box1}>
                <figure>
                  <Image src={AgriClean} id={styles.AgriCleanImage}></Image>
                  <figcaption className={styles.figcaption}>
                    <div className={styles.hl}></div>
                    <div id={styles.TextCleaningCare}>Cleaning Care</div>
                    <div className={styles.hl}></div>
                  </figcaption>
                  <br></br>
                  <figcaption className={styles.textBox}>
                    Want to{" "}
                    <b>
                      kill coronavirus while reducing carbon dioxide in your
                      space
                    </b>
                    ?{" "}
                    <b>
                      <i>AgriClean</i>
                    </b>{" "}
                    effectively disinfects surfaces by absorbing carbon dioxide.
                    Destroys 99.9% of bacteria such as e-coli and coronaviruses.
                    Tiles, hardwood, carpets and rugs, and much more! Laboratory
                    verified. For commercial and home use.
                  </figcaption>
                </figure>
              </div>
            </Col>

            <Col lg={7} className={styles.containerBottom}>
              <div id={styles.Box2}>
                <figure>
                  <Image
                    src={AgriFlower}
                    className={styles.productImage}
                  ></Image>

                  <figcaption className={styles.figcaption}>
                    <div className={styles.hl}></div>
                    <div id={styles.TextFlowerCare}>Flower Care</div>
                    <div className={styles.hl}></div>
                  </figcaption>
                  <br></br>
                  <figcaption className={styles.textBox} id={styles.TextBox2}>
                    Preserve your beautiful cut flowers for 1.5x longer.{" "}
                    <b>
                      <i>AgriFlower</i> naturally extends the life and freshness
                      of cut flowers,
                    </b>{" "}
                    with minimal effort.
                  </figcaption>
                </figure>
              </div>
              <div id={styles.Box3}>
                <figure>
                  <Image src={AgriCool} className={styles.productImage}></Image>
                  <figcaption className={styles.figcaption}>
                    <div className={styles.hl}></div>
                    <div id={styles.TextRefrigeratorCare}>
                      Refrigerator Care
                    </div>
                    <div className={styles.hl}></div>
                  </figcaption>
                  <br></br>
                  <figcaption className={styles.textBox} id={styles.TextBox3}>
                    Odors taking over your fridge? Not anymore.{" "}
                    <b>
                      <i>AgriCool</i> naturally and effectively removes food
                      odour by absorbing carbon dioxide
                    </b>{" "}
                    in refrigerators.
                  </figcaption>
                </figure>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
